module.exports = __webpack_public_path__ + "img/previewImg3.b867c105.png";